import React, { useState, useEffect, Fragment } from "react";
import whats from "../../assets/images/whatsapp.png";
import instagram from "../../assets/images/instagram.png";
import { Link } from "react-router-dom";

const Whats = () => {
  const [footerVisible, setFooterVisible] = useState(false);

  useEffect(() => {
    let observer;

    const observe = () => {
      const footer = document.getElementById("site-footer");
      if (!footer) return false;

      observer = new IntersectionObserver(
        ([entry]) => {
          setFooterVisible(entry.isIntersecting);
        },
        { threshold: 0.05 }
      );

      observer.observe(footer);
      return true;
    };

    if (!observe()) {
      const interval = setInterval(() => {
        if (observe()) clearInterval(interval);
      }, 300);
      return () => {
        clearInterval(interval);
        observer?.disconnect();
      };
    }

    return () => observer?.disconnect();
  }, []);

  return (
    <Fragment>
      {!footerVisible && (
        <div className="fixed bottom-0 right-0 p-3 md:p-5 z-[99999] flex flex-col gap-2 md:gap-3">
          {/* Instagram Link */}
          <Link
            to="https://www.instagram.com/luster_photobooth/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-[60px] md:w-[80px] hover:scale-110 transition-transform"
          >
            <img src={instagram} alt="Instagram" className="w-full" />
          </Link>

          {/* WhatsApp Link */}
          <Link
            to="https://wa.me/+201555339569"
            target="_blank"
            rel="noopener noreferrer"
            className="w-[60px] md:w-[80px] hover:scale-110 transition-transform"
          >
            <img src={whats} alt="WhatsApp" className="w-full" />
          </Link>
        </div>
      )}
    </Fragment>
  );
};

export default Whats;